import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';


export interface Preferences {
  analytics: boolean;
  marketing: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConsentService {

  private readonly KEY = 'gdpr_preferences';
  private readonly SEEN = 'gdpr_seen_banner';
  private readonly ANON = 'gdpr_anon_id';

  private BASE_URL = 'https://hm-api.creatorott.com/gdpr/api/v1';

  constructor(private http: HttpClient) {
    
  }

    getAnonymousId(): string {
    const id = localStorage.getItem(this.ANON);
    if (id) return id;

    const newId = this.generateAnonymousId();
    localStorage.setItem(this.ANON, newId);
    return newId;
  }

  private generateAnonymousId(): string {
    // UUID v4
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  
  // load from localStorage

  
  getLocalPreferences(): Preferences {
    const raw = localStorage.getItem(this.KEY);
    if (!raw) return { analytics: false, marketing: false };
    try {
      return JSON.parse(raw) as Preferences;
    } catch {
      return { analytics: false, marketing: false };
    }
  }

  saveLocalPreferences(prefs: Preferences) {
    localStorage.setItem(this.KEY, JSON.stringify(prefs));
  }

  markBannerSeen() {
    localStorage.setItem(this.SEEN, 'true');
  }

  hasSeenBanner(): boolean {
    return localStorage.getItem(this.SEEN) === 'true';
  }
    loadPreferences() {
      // alert("11111")
    const anonId = this.getAnonymousId(); // send ID
    return this.http.get<Preferences>(`${this.BASE_URL}/get/preferences/anonId/${anonId}`).pipe(
      tap(p => {
        if (p) this.saveLocalPreferences(p);
      })
    );
  }
   addPreferences(prefs: Preferences, userId?: string) {
    const anonId = this.getAnonymousId();

    const formData = new FormData();
    formData.append('anon_id', anonId);
    formData.append('analytics', String(prefs.analytics));
    formData.append('marketing', String(prefs.marketing));

    if (userId) {
      formData.append('user_id', userId);
    }

    return this.http
      .post(`${this.BASE_URL}/add/preferences`, formData)
      .pipe(
        tap(() => this.saveLocalPreferences(prefs))
      );
  }

updatePreferences(prefs: Preferences, userId?: string, anonymousId?: string) {

  const formData = new FormData();
  formData.append('anon_id', anonymousId || this.getAnonymousId());

  if (userId) {
    formData.append('user_id', userId);
  }

  formData.append('analytics', String(prefs.analytics));
  formData.append('marketing', String(prefs.marketing));

  return this.http.post(`${this.BASE_URL}/update/preferences`, formData)
    .pipe(
      tap(() => this.saveLocalPreferences(prefs))
    );
}


//  updatePreferences(prefs: Preferences, userId?: string ,anonymousId?: string) {
//   const anonId = this.getAnonymousId();

//   const formData = new FormData();
//   formData.append('anon_id', anonId);
  
//   if (userId) formData.append('user_id', userId);

//   formData.append('analytics', String(prefs.analytics));
//   formData.append('marketing', String(prefs.marketing));

//   return this.http
//     .post(`${this.BASE_URL}/update/preferences`, formData)
//     .pipe(
//       tap(() => this.saveLocalPreferences(prefs))
//     );
// }

}
